import script from "./BatteryChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatteryChart.vue?vue&type=script&setup=true&lang=ts"

import "./BatteryChart.vue?vue&type=style&index=0&id=249ca9b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-249ca9b4"]])

export default __exports__